import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
    useDeleteStandingOrderMutation,
    useGetStandingOrdersQuery,
} from 'lib/services';
import { CONFIRM_MODAL } from 'constants/shared/modalTypes';
import { hideModal, showModal } from 'actions/modal';
import { formatMoney } from 'lib/utils';
import { PAYMENT_STANDING_ORDER } from 'constants/shared/routes';
import StandingOrderItem from '../presentational/SingleStandingOrder';
import DataCheck from 'components/shared/generic/dataCheck/presentational/DataCheck';
import SectionTitle from 'components/shared/generic/sectionTitle/presentational/SectionTitle';
import useTranslate from 'lib/languages/useTranslate';

const StandingOrderItemContainer = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {
        standingOrders,
        standingOrder,
        isLoading,
        error,
    } = useGetStandingOrdersQuery(undefined, {
        selectFromResult: ({ data, isLoading, error }) => ({
            standingOrders: data,
            standingOrder: data?.find(order => order.id === id),
            isLoading,
            error,
        }),
    });
    const [deleteStandingOrder] = useDeleteStandingOrderMutation();
    const translate = useTranslate('standingOrders.deleteStandingOrderModal');

    const handleDeleteModal = () => {
        dispatch(
            showModal({
                type: CONFIRM_MODAL,
                props: {
                    title: translate('titleText'),
                    message: translate('descriptionText'),
                    // Failed deletion shows error, modal remains open
                    handleSubmit: async () => {
                        await deleteStandingOrder({ id }).unwrap();
                        navigate(PAYMENT_STANDING_ORDER);
                        dispatch(hideModal());
                    },
                },
            }),
        );
    };

    return (
        <>
            <SectionTitle
                title={
                    standingOrder ? (
                        `${standingOrder.bankAccountNo} - £${formatMoney(
                            standingOrder.amount,
                        )}`
                    ) : (
                        <i className="far fa-spinner fa-spin" />
                    )
                }
                backRoute={PAYMENT_STANDING_ORDER}
            />
            <DataCheck
                data={standingOrders}
                isLoading={isLoading}
                error={error}
                noDataMessage="This standing order could not be found."
            >
                <StandingOrderItem
                    data={standingOrder}
                    handleDelete={handleDeleteModal}
                />
            </DataCheck>
        </>
    );
};

export default StandingOrderItemContainer;
